import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
  width: '100%',
  minHeight: 'calc(100vh - 120px)',
});

export const PlansGrid = styled(Box)({
  display: 'flex',
  gap: '24px',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginTop: '40px',
  maxWidth: '1000px',
});

export const PlanCard = styled(Box)({
  background: '#2C325C',
  borderRadius: '12px',
  padding: '32px 24px',
  width: '280px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  transition: 'transform 0.2s, box-shadow 0.2s',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
  },
});

export const PlanCardHighlight = styled(PlanCard)({
  border: '2px solid #ffee58',
  position: 'relative' as const,
});

export const Badge = styled(Box)({
  position: 'absolute' as const,
  top: '-12px',
  background: '#ffee58',
  color: '#1E2141',
  padding: '2px 16px',
  borderRadius: '12px',
  fontWeight: 700,
  fontSize: '12px',
});

export const PriceText = styled(Box)({
  display: 'flex',
  alignItems: 'baseline',
  gap: '4px',
  margin: '16px 0',
});

export const FeatureList = styled(Box)({
  width: '100%',
  marginTop: '16px',
  marginBottom: '24px',
  '& > div': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
    color: '#ffffffcc',
    fontSize: '14px',
  },
});
